var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CompanyWelfareBar"},[_c('h2',[_vm._v("告别传统版本，定制专属授权，尊享超值福利")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_vm._v("\n    咨询电话：021-38760461\n     或 \n    "),_c('a',{attrs:{"href":_vm.serviceLink,"target":"_blank"}},[_vm._v("联系企业客服")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }